import React from 'react';
import { IValueTextRow } from './interface';
import { ValueRow } from '../ValueRow';

export const ValueTextRow: React.FC<IValueTextRow> = ({
  label,
  value,
  width,
}): JSX.Element => {
  return (
    <ValueRow label={label} width={width} verticalAlign="top">
      <span style={{ whiteSpace: 'pre-line' }}>{value}</span>
    </ValueRow>
  );
};
